import { EventEmitter, Injectable, Output } from '@angular/core';
import {
  NavController,
  ModalController,
  AlertController,
  ToastController,
  LoadingController,
  Platform,
} from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { Dialogs } from '@ionic-native/dialogs/ngx';

@Injectable({
  providedIn: 'root',
})
export class UxService {
  loading: HTMLIonLoadingElement;

  @Output() onSalirAlertDimissed = new EventEmitter<boolean>();

  constructor(
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private modalController: ModalController,
    private navCtrl: NavController,
    private dialogs: Dialogs,
    protected platform: Platform
  ) {}

  async showCargando(message?: string) {
    this.loading = await this.loadingController.create({
      message: message || 'Cargando',
      spinner: 'crescent',
      translucent: true,
      cssClass: 'app-loading',
    });

    this.loading.dismiss();

    await this.loading.present();
  }

  hideCargando() {
    if (this.loading) {
      this.loading.dismiss();
      this.loading = undefined;
    }
  }

  async showError(error) {
    console.error(error);
    await this.showToast('Error', error.message, 'alert-danger');
  }

  async alerta(
    header?: string,
    subHeader?: string,
    message?: string,
    token_expired?: boolean
  ) {
    //console.log("APP_ADMISION_LOG ALERTA HEADER " + header);
    let alert = await this.alertCtrl.create({
      cssClass: 'my-alert-custom',
      header: header,
      subHeader: subHeader,
      message: message,
      buttons: [
        {
          text: token_expired ? 'Iniciar Sesión' : 'OK',
          handler: (blah) => {
            if (token_expired) {
              this.navCtrl.navigateRoot(environment.PAGES.horario.url);
              //this.accesoService.logOut();
              this.onSalirAlertDimissed.emit(true);
            }
          },
        },
      ],
    });
    await alert.present();
  }

  async showToast(
    header: string,
    mensaje: string,
    color: string,
    duration?: number,
    position?: 'top' | 'bottom'
  ) {
    const toast = await this.toastCtrl.create({
      header: header,
      message: mensaje,
      color: color,
      position: position || 'top',
      duration: duration || 10000,
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {},
        },
      ],
    });

    this.toastCtrl.dismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }

  async dismissToast() {
    this.toastCtrl.getTop().then((topLoader) => {
      if (topLoader != undefined) {
        this.toastCtrl.dismiss(() => {});
      }
    });
  }

  async presentModal(
    page: any,
    properties: any,
    onDidDismiss: any,
    cssClass?: string
  ) {
    let modal = await this.modalController.create({
      component: page,
      cssClass: cssClass,
      componentProps: properties,
    });
    modal.onDidDismiss = onDidDismiss;
    return await modal.present();
  }

  confirmar2(titulo: string, mensaje: string, callback: any) {
    if (this.platform.is('cordova')) {
      this.dialogs
        .confirm(mensaje, titulo, ['Sí', 'No'])
        .then((data) => callback(data))
        .catch((e) => console.log('Error al mostrar el diálogo', e));
    } else {
      console.log('No se puede mostrar el dialogo en navegador web');
      callback(null);
    }
  }

  async confirmar(titulo: string, mensaje: string) {
    try {
      if (this.platform.is('cordova')) {
        return await this.dialogs.confirm(mensaje, titulo, ['Sí', 'No']);
      } else {
        console.log('No se puede mostrar el dialogo en navegador web.');
        return null;
      }

      this.dialogs
        .confirm('Hello world')
        .then(() => console.log('Dialog dismissed'))
        .catch((e) => console.log('Error displaying dialog', e));
    } catch (error) {
      console.log('No se puede mostrar el dialogo. ', error);
      return null;
    }
  }
}
